import { render } from "./FeatureList.vue?vue&type=template&id=5df40f69&scoped=true"
import script from "./FeatureList.vue?vue&type=script&lang=js"
export * from "./FeatureList.vue?vue&type=script&lang=js"

import "./FeatureList.vue?vue&type=style&index=0&id=5df40f69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df40f69"]])

export default __exports__